import { RECORDS_PER_PAGE } from '@/constants/data';
import BaseService from './base.service';

const baseService = new BaseService('directive-admin');

function buildQueryParams(params: Record<string, any>): URLSearchParams {
  const queryParams = new URLSearchParams({
    page: String(params.page || 1),
    perPage: String(RECORDS_PER_PAGE),
  });

  const searchTerm = params.firstname?.trim() || params.search?.trim();
  if (searchTerm) queryParams.append('search', searchTerm);
  if (params.lastname?.trim()) queryParams.append('lastname', params.lastname.trim());
  if (params.dni?.trim()) queryParams.append('dni', params.dni.trim());
  if (params.active != null) queryParams.append('active', String(params.active));
  if (params.school_id) queryParams.append('school_id', params.school_id);
  queryParams.append('_ts', String(Date.now()));

  return queryParams;
}

export default {
  getDirectiveAdmins: (params: any = {}) => baseService.get(`findAll?${buildQueryParams(params)}`),
  createDirectiveAdmin: (data: any) => baseService.post('create', data),
  updateDirectiveAdmin: (id: number, data: any) => baseService.put(`update/${id}`, data),
  getDirectiveAdmin: (id: number) => baseService.get(`findOne/${id}`),
  getAvailableSchools: (params: any = {}) => {
    const queryParams = new URLSearchParams();
    if (params.country_id) queryParams.append('country_id', params.country_id);
    if (params.school_group_id) queryParams.append('school_group_id', params.school_group_id);
    return baseService.get(`available-schools?${queryParams}`);
  },
  deleteMultipleDirectiveAdmins: (ids: number[]) => baseService.del('delete-multiple', { ids }),
};
